import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="transparent"
    stroke="currentColor"
    {...props}
  >
    <path d="M2.5 4C2.5 2.61929 3.61929 1.5 5 1.5H13.913C14.5978 1.5 15.2527 1.78091 15.7246 2.27713L21.5 8.3498V20C21.5 21.3807 20.3807 22.5 19 22.5H5C3.61929 22.5 2.5 21.3807 2.5 20V4Z" />
    <path
      d="M11.9997 14.25V15.4167M8.49967 17.75H15.4997C16.144 17.75 16.6663 17.2277 16.6663 16.5833V13.0833C16.6663 12.439 16.144 11.9167 15.4997 11.9167H8.49967C7.85534 11.9167 7.33301 12.439 7.33301 13.0833V16.5833C7.33301 17.2277 7.85534 17.75 8.49967 17.75ZM14.333 11.9167V9.58333C14.333 8.29467 13.2883 7.25 11.9997 7.25C10.711 7.25 9.66634 8.29467 9.66634 9.58333V11.9167H14.333Z"
      strokeLinecap="round"
    />
  </svg>
);
